// extracted by mini-css-extract-plugin
export default {"periodButtons":"RatiosPeriodButtons_periodButtons__+Xa6z","periodBtn":"RatiosPeriodButtons_periodBtn__zGebd","activeBtn":"RatiosPeriodButtons_activeBtn__6l1ew"};